<template>
  <!-- ApexChart -->

  <div>
    <apexchart
      type="area"
      width="100%"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "StatusChart",
  props: {
    service: Object,
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: "area",
          zoom: {
            enabled: false,
          },
        },
        tooltip: {
          theme: "dark",
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: this.categories,
        },
        fill: {
          type: "gradient",
          gradient: {
            gradientToColors: ["#ff0000"],
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
      };
    },
    categories() {
      const today = new Date();
      const past14Days = Array.from({ length: 14 }, (_, i) => {
        const pastDate = new Date(today);
        pastDate.setDate(today.getDate() - i);
        return pastDate.toISOString().split("T")[0];
      });
      return past14Days.reverse().map((date) => moment(date).format("DD MMM"));
    },
    series() {
      return [
        {
          name: "Uptime",
          // Round the value to 0 decimal places
          data: this.service.uptime.map((x) => Math.round(x * 100) / 100),
          color: "#00FF00",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
